import React from "react";
import { Form, Input, Row, Col } from "antd";

const Profile: React.FC = () => {
  return (
    <div style={{ padding: "20px" }}>
      {/* Top Banner */}
      <div className="profile-headers">Profile</div>
      <div
        style={{
          height: "198px",
          width: "100%",
          borderRadius: "10px",
          backgroundImage: "url('/Home/fastestBg.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        {/* Profile Image Overlapping */}
        <div
          style={{
            position: "absolute",
            left: "50%",
            bottom: "-66px", // Half of 132px
            transform: "translateX(-50%)",
            borderRadius: "50%",
            width: "132px",
            height: "132px",
            border: "5px solid #fff",
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          <img
            src={'/Home/newBg.svg'}
            alt="Profile"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      {/* Form Section */}
      <div style={{ marginTop: "100px", maxWidth: "1044px", marginInline: "auto" }}>
        <Form layout="vertical">
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Form.Item
                label={<span style={{ fontSize: "14px", fontWeight: 500 }}>First Name</span>}
                style={{
                  border: "1px solid rgba(0,0,0,0.4)",
                  borderRadius: "6px",
                  padding: "10px 15px",
                  height: "76px",
                }}
              >
                <Input
                  placeholder="Enter first name"
                  style={{ fontSize: "16px", border: "none", boxShadow: "none" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={<span style={{ fontSize: "14px", fontWeight: 500 }}>Last Name</span>}
                style={{
                  border: "1px solid rgba(0,0,0,0.4)",
                  borderRadius: "6px",
                  padding: "10px 15px",
                  height: "76px",
                }}
              >
                <Input
                  placeholder="Enter last name"
                  style={{ fontSize: "16px", border: "none", boxShadow: "none" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={<span style={{ fontSize: "14px", fontWeight: 500 }}>Email</span>}
                style={{
                  border: "1px solid rgba(0,0,0,0.4)",
                  borderRadius: "6px",
                  padding: "10px 15px",
                  height: "76px",
                }}
              >
                <Input
                  placeholder="Enter email"
                  style={{ fontSize: "16px", border: "none", boxShadow: "none" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default Profile;
